//Models
PJQ.models.userMessages = {};

PJQ.models.userMessages.UserMessage = PJQ.models.BaseModel.extend({
	idAttribute: 'userMessageId',
	endpoint: function () {
		if (this.id > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'usermessages',
					value: this.id
				}
			]);
		}
		else if (this.get('replyToMessageId') > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'usermessages',
					value: this.get('replyToMessageId')
				}
			]);
		}
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.project.id
			},
			{
				endpoint: 'usermessages'
			}
		]);
	},
	parse: function (model) {
		if (model !== null && model !== undefined) {
			this.project = model.project;

			if (model.from != null) {
				this.from = new PJQ.models.contacts.Contact(model.from);
			}

			if (model.to != null) {
				this.to = new PJQ.models.contacts.Contact(model.to);
			}

			this.attachments = new PJQ.collections.files.Files(model.attachments);
			this.attachments.on('update', _.bind(function () {
				this.isDirty = true;
			}, this));
		}
		else {
			this.attachments = new PJQ.collections.files.Files();
		}
		return model;
	},
	beforeSave: function () {
		this.set('attachments', this.attachments.getChangedModels());

		if (this.userMessageType != null) {
			this.set('userMessageTypeId', this.userMessageType.id);
		}
	},
	updateViewed: function(){
		this.set('viewedOn', new Date());
		if(this.id > 0){
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'usermessages',
						value: this.id
					},
					{
						endpoint: 'viewed'
					}
				])
			}).put();
		}
	}
});

PJQ.models.userMessages.UserMessageType = PJQ.models.BaseModel.extend({
	idAttribute: 'internalMessageTypeId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'usermessages'
			},
			{
				endpoint: 'types',
				value: this.id
			}
		])
	}
});

//Collections
PJQ.collections.userMessages = {};

PJQ.collections.userMessages.UserMessages = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.userMessages.UserMessage,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.id
			},
			{
				endpoint: 'usermessages',
				value: this.options.userId
			},
			{
				endpoint: _.size(this.options.view) > 0 ? this.options.view : 'inbox'
			}
		]);
	}
});

PJQ.collections.userMessages.UserMessageThread = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.userMessages.UserMessage,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'usermessages',
				value: this.options.message.id
			},
			{
				endpoint: 'thread'
			}
		]);
	}
});

PJQ.collections.userMessages.UserMessageTypes = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.userMessages.UserMessageType,
	endpoint: function () {
		if (this.options.project != null && this.options.project.id > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.options.project.id
				},
				{
					endpoint: 'usermessages'
				},
				{
					endpoint: 'types'
				}
			]);
		}
		else {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'usermessages'
				},
				{
					endpoint: 'types'
				}
			]);
		}
	}
});